import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
}

export const MainContent = (props: MainContentProps) => {
  return (
    <div className="main-content flex h-full flex-1 flex-col mobile:w-full">
      {props.children}
    </div>
  );
};
